import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useTranslate from 'common/I18n/Interpreter';

export const calculateTimeLeft = difference => {
  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      difference: +difference,
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  return timeLeft;
};

const TimerItem = ({ value }) => {
  if (value === undefined || value === null) {
    return null;
  }

  const splitValue = value.toString().split('');

  return value.toString().length === 2 ? (
    <div>
      <span className="title-bold-text">{splitValue[0]}</span>
      <span className="title-bold-text">{splitValue[1]}</span>
    </div>
  ) : (
    <div>
      <span className="title-bold-text">0</span>
      <span className="title-bold-text">{splitValue[0]}</span>
    </div>
  );
};

TimerItem.propTypes = { value: PropTypes.number.isRequired };

const CountdownTimer = ({ time, simpleWithDot = false, showSeconds = true }) => {
  const t = useTranslate();

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(time));

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setTimeLeft(prevTimeLeft => {
        const newDiff = +prevTimeLeft.difference - 1000;

        return {
          difference: newDiff,
          days: Math.floor(newDiff / (1000 * 60 * 60 * 24)),
          hours: Math.floor((newDiff / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((newDiff / 1000 / 60) % 60),
          seconds: Math.floor((newDiff / 1000) % 60),
        };
      });
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [timeLeft]);

  if (timeLeft.difference <= 0) {
    return <span className="time-over">{t('time_over')}</span>;
  }

  if (simpleWithDot) {
    return (
      <div className="simple-timer sub-title-small-text">
        <TimerItem value={timeLeft.days} />: <TimerItem value={timeLeft.hours} />:{' '}
        <TimerItem value={timeLeft.minutes} />:
        {showSeconds && (
          <>
            {' '}
            <TimerItem value={timeLeft.seconds} />
          </>
        )}
      </div>
    );
  }

  return (
    <div className="simple-timer sub-title-small-text">
      <TimerItem value={timeLeft.days} />
      <span>{t('timer_d')}</span> <TimerItem value={timeLeft.hours} />
      <span>{t('timer_h')}</span> <TimerItem value={timeLeft.minutes} />
      <span>{t('timer_m')}</span>
      {showSeconds && (
        <>
          {' '}
          <TimerItem value={timeLeft.seconds} />
          <span>{t('timer_sec')}</span>
        </>
      )}
    </div>
  );
};

CountdownTimer.propTypes = {
  time: PropTypes.number.isRequired,
  showSeconds: PropTypes.bool,
};

export default CountdownTimer;
